import React from "react";

import {
    Divider,
    IconButton,
    Menu,
    MenuItem,
    styled,
    Typography,
} from "@mui/material";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";

import { useAppSelector } from "app/hooks";
import { playbackSelectors } from "./store/selectors.playback";

const IconButtonWhite = styled(IconButton)(({ theme }) => ({
    color: theme.palette.common.white,
    ":disabled": {
        color: theme.palette.common.white,
        opacity: "30%",
    },
}));

export interface PlaybackSettingsPopOverProps {
    onPlaybackSpeedChanged: (playSpeed: number) => void;
}

export function PlaybackSettingsPopOver(props: PlaybackSettingsPopOverProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const playbackSpeedOptions = useAppSelector(
        playbackSelectors.selectPlaybackSpeedOptions,
    );
    const playSpeed = useAppSelector(playbackSelectors.selectPlaybackSpeed);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButtonWhite
                aria-label="settings"
                onClick={handleClick}
            >
                <Typography
                    variant="body2"
                    style={{ marginLeft: "4px" }}
                >
                    {playSpeed}x
                </Typography>
            </IconButtonWhite>
            <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "lock-button",
                    role: "listbox",
                    dense: true,
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <MenuItem>
                    <SlowMotionVideoIcon />
                    <Typography
                        variant="body1"
                        component="span"
                        sx={{ ml: 1 }}
                    >
                        Playback Speed
                    </Typography>
                </MenuItem>
                <Divider sx={{ my: 1 }} />
                {playbackSpeedOptions.map((option) => (
                    <MenuItem
                        key={option}
                        onClick={() => {
                            props.onPlaybackSpeedChanged(option);
                            setAnchorEl(null);
                        }}
                    >
                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
